import * as types from './type'
import * as api from './api'

export default {
  state: {
    state: 1,
    totrust: 0,
    taskInfo: {
      uid: 0,
      avatar: '',
      balance: 0,
      team_member_num: 0,
      team_money: 0,
      running: [],
      upcoming: [],
      pop_bind_cert: false
    },
    taskDetail: {},
    taskStatus: {}
  },
  mutations: {
    dashboardObjState (state, obj) {
      if (!state[obj.key]) return
      state[obj.key] = Object.assign(state[obj.key], obj.val)
    },
    dashboardState (state, obj) {
      state[obj.key] = obj.val
    }
  },
  actions: {
    // 应用任务列表
    async [types.URI_APPTASK_LIST] ({ commit }) {
      let res = await api.getTaskInfo()
      if (res && res.status === 200) {
        commit('dashboardObjState', { key: 'taskInfo', val: res.data.payload })
      }
      return res
    },
    // 进行中的任务
    async [types.URI_APPTASK_START] ({ commit }, params) {
      let res = await api.runingTask(params)
      if (res && res.status === 200) {
        commit('dashboardObjState', { key: 'taskInfo', val: res.data.payload })
      }
      return res
    },
    // 任务详情
    async [types.URI_APPTASK_DETAIL] ({ commit }, params) {
      let res = await api.taskDetail(params)
      if (res && res.status === 200) {
        commit('dashboardState', { key: 'taskDetail', val: res.data.payload })
      }
      return res
    },
    // 放弃任务
    async [types.URI_APPTASK_GIVEUP] ({ commit }, params) {
      let res = await api.giveUpTask(params)
      if (res && res.status === 200) {
        commit('dashboardState', { key: 'taskDetail', val: {} })
      }
      return res
    },
    // 领取红包
    async [types.URI_APPTASK_CHECK_STATUS] ({ commit }, params) {
      let res = await api.checkStatusTask(params)
      if (res && res.status === 200) {
        commit('dashboardState', { key: 'taskStatus', val: res.data.payload })
      }
      return res
    },
    // 用户证书
    async [types.URI_START] ({ commit }, params) {
      // assistant_trust: ''
      let res = await api.start()
      if (res && res.status === 200) {
        commit('dashboardState', { key: 'state', val: res.data.payload.state })
        commit('dashboardState', { key: 'totrust', val: res.data.payload.tt })
      }
      return res
    }
  }
}
